import './Layout.scss';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getIsLoggedIn } from '../UserData/userDataEntity';
import { getUserAttributes } from '../UserData/userDataActions';
import Header from './Header/Header';
import Navigation from '../Navigation/Navigation';
import MerchantSelector from '../MerchantSelector/MerchantSelector';
import Popup from '../MerchantSelector/Popup/Popup';
import { getIsSelectorOpen } from '../MerchantSelector/merchantSelectorViewState';
import { logout } from '../Login/loginActions';
import { changeRoute } from '../Routes/routesActions';
import Body from './Body/Body';
import CreateUser from '../UserManagement/CreateUser/CreateUser';
import EditUser from '../UserManagement/EditUser/EditUser';
import EditRule from '../PaymentRouting/EditUser/editRule.js';
import PrevetForm from '../MerchantDetailsPage/PrevetForm/PrevetForm';
import EditPrevetForm from '../MerchantDetailsPage/PrevetForm/EditPrevetForm';
import CreateApplicationModal from '../LeadToLive/CreateApplicationModal/CreateApplicationModal';
import { historyShape, selfShape } from '../../utils/propTypes';
import { refreshToken } from '../Refresh/refreshActions';
import { throttle } from 'lodash';
import Void from '../Void/Void';
import Refund from '../Refund/Refund';
import Capture from '../Capture/Capture';
import UploadPayouts from '../Payouts/UploadPayouts/UploadPayouts';
import RejectBatch from '../PayoutBatch/RejectBatch';
import UserMessage from '../UserMessage/UserMessage';
import { getIsLoading as getIsSelfLoading, getSelf } from '../Self/selfEntity';
import { toggleModal } from '../Modal/modalActions';
import { hasSeenUserMessageThisSession, markUserMessageSeenThisSession, updateLastLogin } from './layoutActions';
import moment from 'moment';
import _ from 'lodash';
import { EmvioLoadingSpinner as LoadingSpinner } from '@nexio/emvio-util-ui';

// RIV-779: bank-descriptor announcement window for accounts with a 9289 MID
const USER_MESSAGE_START = moment.utc('2026-09-29T17:00:00Z');
const USER_MESSAGE_END = moment.utc('2026-10-07T00:00:00Z'); // end TBD, confirm with requester
const USER_MESSAGE_MID_PREFIX = '9289';

export class Layout extends Component {
    static propTypes = {
        bodyComponent: PropTypes.node,
        children: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node
        ]),
        history: historyShape,
        isErrorPage: PropTypes.bool,
        isLoggedIn: PropTypes.bool,
        isSelfLoading: PropTypes.bool,
        isMerchantSelectorOpen: PropTypes.bool,
        isSearchOpen: PropTypes.bool,
        onChangeRoute: PropTypes.func,
        self: selfShape,
        onGetUserAttributes: PropTypes.func,
        onOpenNexioAgreement: PropTypes.func,
        onLogout: PropTypes.func,
        onRefreshToken: PropTypes.func,
        routesList: PropTypes.any,
        shouldRemoveBodyMargins: PropTypes.bool,
        onToggleUserMessageModal: PropTypes.func,
        onUpdateLastLogin: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.props.history.listen(this.props.onChangeRoute);

        this.handleLogout = this.handleLogout.bind(this);
    }

    componentDidMount() {
        this.checkForUserMessage();
        this.props.onUpdateLastLogin();
        this.props.onGetUserAttributes();
    }

    checkForUserMessage() {
        const merchantIds = Object.keys(_.get(this, 'props.self.accessRights.merchantIds', {}));
        const hasQualifyingMid = merchantIds.some((id) => String(id).startsWith(USER_MESSAGE_MID_PREFIX));
        const inWindow = moment().isBetween(USER_MESSAGE_START, USER_MESSAGE_END);

        if (hasQualifyingMid && inWindow && !hasSeenUserMessageThisSession()) {
            markUserMessageSeenThisSession();
            this.props.onToggleUserMessageModal();
        }
    }

    handleLogout() {
        this.props.onLogout();
        this.props.history.push('/');
    }

    render() {
        return (
            <div className="emvio-layout" onKeyDown={this.props.onRefreshToken}>
                <Navigation
                    routesList={this.props.routesList}
                    merchantSelector={<MerchantSelector />}
                />
                {this.props.selfLoading ? (
                    <LoadingSpinner />
                ) : (
                    <>
                        <div className="layout-page">
                            <Popup />
                            <Header
                                isErrorPage={this.props.isErrorPage}
                                isSearchOpen={this.props.isSearchOpen}
                                history={this.props.history}
                            />
                            <div className="layout-body">
                                <Body shouldRemoveBodyMargins={this.props.shouldRemoveBodyMargins}>
                                    {this.props.children}
                                </Body>
                            </div>
                        </div>
                        <UserMessage />
                        <CreateUser />
                        <EditUser />
                        <EditRule />
                        <PrevetForm />
                        <EditPrevetForm />
                        <CreateApplicationModal />
                        <Void />
                        <Refund />
                        <Capture />
                        <RejectBatch />
                        <UploadPayouts />
                    </>
                )}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        isSelfLoading: getIsSelfLoading(state),
        self: getSelf(state),
        isLoggedIn: getIsLoggedIn(state),
        isMerchantSelectorOpen: getIsSelectorOpen(state)
    };
}

const throttledRefreshTokens = throttle((dispatch) => dispatch(refreshToken()), 60000);

function mapDispatchToProps(dispatch) {
    return {
        onChangeRoute: (location, action) => dispatch(changeRoute(location, action)),
        onGetUserAttributes: () => getUserAttributes(dispatch),
        onLogout: () => dispatch(logout()),
        onRefreshToken: () => throttledRefreshTokens(dispatch),
        onToggleUserMessageModal: () => dispatch(toggleModal('userMessage')),
        onUpdateLastLogin: () => dispatch(updateLastLogin())
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout));
